<template>
  <ElRate disabled :value="row.rate" :colors="ratingColors" />
</template>

<script>
export default {
  name: 'KeywordPlannerValueColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ratingColors() {
      return ['#6B6B6B', '#6B6B6B', '#6B6B6B'];
    },
  },
};
</script>
